import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import LoadingComp from "../../components/re-usable/loading/loading";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import { RootState, useAppDispatch } from "../../redux/store";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import ConferenceBanner from "./components/convergence-2024-banner";
import PageNotFound from "../errors/page-not-found";
import RegisterAccordion from "../../components/re-usable/accordion/register.conference"
import ProfileAccordion from "../../components/re-usable/accordion/profile.conference"

const Convergence2024Index = () => {
  const { "*": urlPath } = useParams();
  const formattedPath = urlPath?.replaceAll("/", "%2F");

  const path = `%2FConvergence-2024%2F${formattedPath}`;

  const dispatch = useAppDispatch();
  const { RapsEuropeData: pageMenuData, RapsEuropeLoading: pageMenuLoading, pageNotFound } = useSelector((state: RootState) => state.rapsEurope);

  const [isPublished, setIsPublished] = useState(false);

  const [scriptHtmlString, setScriptHtmlString] = useState("");
  const [isPageNotFound, setIsPageNotFound] = useState(!pageMenuLoading && pageNotFound);

  useEffect(() => {
    dispatch(retrievePageMenu(path));
  }, [dispatch]);

  useEffect(() => {
    if (pageMenuData[0]?.result) {
      setIsPublished(true);
    }
    else if (!pageMenuLoading && pageNotFound) {
      setIsPageNotFound(true);
    }
  }, [pageMenuData]);

  useEffect(() => {
    if (isPublished) {
      if (pageMenuData[0].result[0]?.javaScriptField)
        setScriptHtmlString(pageMenuData[0].result[0]?.javaScriptField);
    }
  }, [isPublished])

  useDynamicScripts({ htmlScriptString: scriptHtmlString });

  if (isPageNotFound) return <PageNotFound />;
  if (!isPublished) return <LoadingComp />;

  return (
    <>
      <CustomStyleComponent />
      <Helmet>
        <title>{pageMenuData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <ConferenceBanner
        bannerImage={pageMenuData[0]?.result[0]?.mainHeaderImage}
        mobileBanner={pageMenuData[0]?.result[0]?.mobileHeaderImage}
        headerText={pageMenuData[0]?.result[0]?.headerText}
        topCommonMesage={pageMenuData[0]?.result[0]?.topCommonMesage}
      />
      <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.description }}></div>
      {path.toLowerCase().indexOf('register') > 0 && <RegisterAccordion path={path} />}
      {path.toLowerCase().indexOf('profile') > 0 && <ProfileAccordion path={path} />}
      <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.councilDescription }}></div>
      <div dangerouslySetInnerHTML={{ __html: pageMenuData[0]?.result[0]?.popupContent }}></div>
    </>
  );
};

export default Convergence2024Index;

const CustomStyleComponent = () => {
  return (
    <>
      <style>
        {`
        `}
      </style>
    </>
  );
};
